import { footerColumns } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1.6fr_1fr_1fr_1fr] gap-10 md:gap-8">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-shield-cross-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">缅北黑料</span>
            </div>
            <p className="mt-5 text-sm leading-7 text-background-100/70 max-w-sm">
              收录缅北黑料亲历者与受害者的讲述、经历与口述自述，还原被困细节与逃生过程，用真实故事警示更多人远离骗局。
            </p>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">{column.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/70 hover:text-primary-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs leading-6 text-background-100/60 max-w-2xl">
            本站内容为亲历者口述与公开资料整理，仅用于反诈警示与安全教育，不指向任何具体个人。
          </p>
          <p className="text-xs text-background-100/60 whitespace-nowrap">© 2026 缅北黑料 · 亲历者口述档案</p>
        </div>
      </div>
    </footer>
  );
}